import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { getImageAltText } from "../utils/manipulation";
import { useMatchMedia } from "../utils/useMatchMedia";

function fixOptimisedSVG(svg) {
  //gatsby-transform-inline-svg plugin provides the .svg property for Contentful Assets
  //It also optimises the SVG content, using SVGO. This optimisation process is changing
  //the IDs of the paths inside the SVG to letters of the alphabet, causing non-unique IDs
  //when you have multiple SVGs on the same page. This is causing muntedness.
  //This function does some find/replace on the IDs and references to them to make them unique for
  //each SVG.
  const uniqueString = Math.random().toString(16).slice(2) + "-"; //chances of ID collision are very slim, but not 0. I like to live dangerously.
  svg = svg.replaceAll(`id="`, `id="${uniqueString}`);
  svg = svg.replaceAll(`url(#`, `url(#${uniqueString}`);
  svg = svg.replaceAll(`href="#`, `href="#${uniqueString}`);
  svg = svg.replaceAll(`viewBox`, `height="100%" width="100%" viewBox`);
  return svg;
}

// Render inline SVG with fallback non-svg images
export default function Image({
  image,
  alt,
  animation,
  imgClassName,
  ...props
}) {
  const isDesktop = useMatchMedia("(min-width: 768px)");
  // if (animation && animation.animatedSvg.svg.originalContent) {
  //   return (
  //     <div
  //       dangerouslySetInnerHTML={{
  //         __html: animation.animatedSvg.svg.originalContent,
  //       }}
  //       {...props}
  //     />
  //   );
  // }
  if (animation && animation.animatedSvg && image) {
    // animated SVGs only appear to work with Object or Embed elements. Object is preferred as it falls back to an image:
    return (
      <object
        data={animation.animatedSvg.file.url}
        type="image/svg+xml"
        title={alt ? alt : getImageAltText(animation.animatedSvg)}
        aria-label={alt}
        height={
          isDesktop ? animation.animatedSvg.file.details.image.height : "100%"
        }
        width="100%"
      >
        {image?.file?.url && (
          <img
            src={image.file.url && image.file.url}
            alt={alt ? alt : getImageAltText(image)}
            title={image.title ? image.title : ""}
            className={imgClassName}
            loading="lazy"
            {...props}
          />
        )}
      </object>
    );
  }

  if (animation && animation.animatedSvg) {
    // if there is no image to fallback to:
    return (
      <object
        data={animation.animatedSvg.file.url}
        type="image/svg+xml"
        title={alt ? alt : getImageAltText(animation.animatedSvg)}
        aria-label={alt}
        height={animation.animatedSvg.file.details.image.height}
        width="100%"
      />
    );
  }

  if (image) {
    if (image.file && image.file.contentType === "image/svg+xml") {
      if (image.svg) {
        //return inline SVG
        if (image.svg.content) {
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: fixOptimisedSVG(image.svg.content),
              }}
              {...props}
            />
          );
        } else {
          if (image.file.url) {
            // SVGs that can/should not be inlined
            return (
              <>
                {image.file.url && (
                  <img
                    src={image.file.url && image.file.url}
                    alt={alt ? alt : getImageAltText(image)}
                    title={image.title ? image.title : ""}
                    className={imgClassName}
                    loading="lazy"
                    {...props}
                  />
                )}
              </>
            );
          }
        }
      }
    }

    // Non SVG images

    return (
      <>
        {image.gatsbyImageData && image.gatsbyImageData?.images && (
          <GatsbyImage
            image={image.gatsbyImageData}
            alt={alt ? alt : getImageAltText(image)}
            title={alt ? alt : getImageAltText(image)}
            imgClassName={imgClassName}
            {...props}
          />
        )}
      </>
    );
  }
  return "";
}
